import React from "react";
import PaymentMethod from "../components/PaymentMethod";

function SelectPaymentMethod() {
  return (
    <section className="models-section">
      <div className="container">
        <PaymentMethod />
      </div>
    </section>
  );
}

export default SelectPaymentMethod;
